import { css } from 'linaria';

export const root = css`
  margin: var(--space-150) 0;
  cursor: pointer;
`;

export const gallery = css`
  display: flex;
  justify-content: space-between;
  margin-top: var(--space-150);
`;

const rectangle = `
  content: '';
  position: absolute;
  width: 6px;
  height: 4px;
  background-color: var(--background-primary);
`;

export const galleryItem = css`
  position: relative;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  height: 70px;
  margin-right: var(--space-75);
  background: rgba(33, 40, 43, 0.05);
  border-radius: var(--rounding-m);

  &:last-of-type {
    margin-right: 0;
  }

  @media (--only-desktop) {
    height: 50px;
  }

  @media (--from-largeDesktop) {
    width: 70px;
  }

  &:not(:first-of-type)&:before {
    ${rectangle}
    left: 0;
  }

  &:not(:last-of-type)&:after {
    ${rectangle}
    right: 0;
  }
`;

export const image = css`
  width: 56px;
  height: 56px;

  @media (--only-desktop) {
    width: 36px;
    height: 36px;
  }
`;

export const stocksButton = css`
  padding: 0 !important;
  --button-hover-bg: unset !important;
`;

export const drawerButton = css`
  width: 100%;
`;

export const drawerContent = css`
  @media (--only-mobile) {
    position: relative;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
`;
